import script from "./RetirementChoicesHL.vue?vue&type=script&setup=true&lang=ts"
export * from "./RetirementChoicesHL.vue?vue&type=script&setup=true&lang=ts"

import "./RetirementChoicesHL.vue?vue&type=style&index=0&id=6c068f5e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c068f5e"]])

export default __exports__